<template>
    <div class="connectionContainer">
        <div class="connectionHeader">
            <div class="modal_title"> CRM広告費設定</div>
        </div>
        <div class="connectionContents">
            <div class="modal_body">
                <div class="modal_form">
                    <div class="modal_input">
                        <label>店舗</label>
                        <select v-model="ad.service_id">
                            <option value="" disabled>店舗</option>
                            <option v-for="service in filteredService()" :value="service.id" v-bind:key="service.id">{{
                                service.name
                            }}</option>
                        </select>
                    </div>
                    <div class="modal_input">
                        <label>配信期間</label>
                        <datepicker format="yyyy-MM-dd" :language="ja" calendar-class="calendarDate"
                            input-class="inputDate" wrapper-class="dispPeriodInput" placeholder="配信開始日"
                            v-model="datePickerStartDate"
                            :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }" />
                        ～
                        <datepicker format="yyyy-MM-dd" :language="ja" calendar-class="calendarDate"
                            input-class="inputDate" wrapper-class="dispPeriodInput" placeholder="配信終了日"
                            v-model="datePickerEndDate"
                            :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }" />
                    </div>
                    <div class="modal_input">
                        <label>配信対象商品</label>
                        <div v-for="(product, index) in this.selectedProducts" :key="index">
                            <span class="dispAdMenu" :class="{ 'selected': modalShow == true }"
                                @click="showSelectProduct(product.id, index)">
                                <span class="productName">{{ product.name }}</span>
                            </span>
                            <div>
                                <span class="btn deleteBtn" @click="delProduct(product.id)">削除</span>
                            </div>
                        </div>
                        <div>
                            <span class="btn" @click="addProduct">商品追加</span>
                        </div>
                    </div>
                    <div class="modal_input">
                        <label>広告費</label>
                        <input type="text" placeholder="広告費" v-model="ad.cost">
                    </div>
                </div>
                <div class="modal_submit">
                    <template v-if="createMode">
                        <Button width="100px" @click="createAd">追加</Button>
                    </template>
                    <template v-else>
                        <Button width="100px" @click="updateAd">更新</Button>
                        <Button width="100px" @click="copyAd" class="copyBtn">複製</Button>
                    </template>
                </div>
                <p v-if="errorMessage" class="copyError">{{ errorMessage }}</p>
            </div>
        </div>
        <div class="connectionFooter">
            <template v-if="!createMode">
                <Button class="btn deleteBtn" @click="openDeleteModal">削除</Button>
            </template>
        </div>
        <modal name="selectProduct" :draggable="false" :resizable="false" width="70%" height="80%"
            @closed="modalClosed">
            <ShowProduct modal-type="privateAd" @modalClosed="modalClosed('selectProduct')" :value="selectedProductId"
                :selectedProductAndRateIndex="selectedProductIndex" @selectProduct="updateProduct" />
        </modal>
        <modal name="deleteModal" :draggable="false" :resizable="false" width="60%" height="200px">
            <DeleteModal @canceled="closeDeleteModal" @deleted="deleteAd" />
        </modal>
    </div>
</template>

<script>
import DeleteModal from './DeleteModal.vue';
import ShowProduct from '../views/ShowProduct.vue'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'

export default {
    props: {
        createMode: Boolean,
        adId: Number,
    },
    components: {
        DeleteModal,
        ShowProduct,
        Datepicker,
    },
    data() {
        return {
            ad: {},
            services: {},
            ja: ja,
            datePickerStartDate: null,
            datePickerEndDate: null,
            selectedProducts: [],
            selectedProductId: null,
            selectedProductIndex: null,
            modalShow: false,
            oldServiceId: null,
            oldStartDate: null,
            oldEndDate: null,
            oldProducts: [],
            oldCost: null,
            errorMessage: '',
        }
    },
    mounted: function () {
        //サービス名プルダウンセット
        this.getServiceId();
        if (this.adId) {
            this.fetchCrmAds(this.adId);
        }
    },
    methods: {
        //サービスIDの一覧取得
        getServiceId: function () {
            this.$store.dispatch("loading", true);
            this.axios.get("/api/service/")
                .then((res) => {
                    this.services = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },

        //追加
        createAd: function () {
            this.$store.dispatch("loading", true);

            const data = {
                service_id: this.ad.service_id,
                media_id: 18,
                start_date: this.$dayjs(this.datePickerStartDate).format("YYYY-MM-DD"),
                end_date: this.$dayjs(this.datePickerEndDate).format("YYYY-MM-DD"),
                products: this.selectedProducts,
                cost: this.ad.cost,
            };
            this.axios.post("/api/privateAds/", data)
                .then(() => {
                    this.modalClose();
                }).catch(() => {
                }).finally(() => {
                });
        },

        //更新
        updateAd: function () {
            this.$store.dispatch("loading", true);

            const data = {
                service_id: this.ad.service_id,
                media_id: 18,
                start_date: this.$dayjs(this.datePickerStartDate).format("YYYY-MM-DD"),
                end_date: this.$dayjs(this.datePickerEndDate).format("YYYY-MM-DD"),
                products: this.selectedProducts,
                cost: this.ad.cost,
            };

            this.axios.put("/api/privateAds/" + this.adId, data)
                .then(() => {
                    this.modalClose();
                }).catch(() => {
                }).finally(() => {
                });
        },

        //複製
        copyAd: function () {
            this.errorMessage = '';

            var start = this.$dayjs(this.datePickerStartDate).format("YYYY-MM-DD");
            var end = this.$dayjs(this.datePickerEndDate).format("YYYY-MM-DD");

            if (this.oldServiceId == this.ad.service_id && this.oldStartDate == start && this.oldEndDate == end) {
                this.errorMessage = '同一店舗、同一期間で複製はできません。';
            }

            else {
                this.$store.dispatch("loading", true);

                const data = {
                    service_id: this.ad.service_id,
                    media_id: 18,
                    start_date: start,
                    end_date: end,
                    products: this.selectedProducts,
                    cost: this.ad.cost,
                };
                this.axios.post("/api/privateAds/", data)
                    .then(() => {
                        this.modalClose();
                    }).catch(() => {
                    }).finally(() => {
                    });
            }
        },

        //削除
        deleteAd: function () {
            this.$store.dispatch("loading", true);

            this.axios.delete("/api/privateAds/" + this.adId)
                .then(() => {
                    this.modalClose();
                }).catch(() => {
                }).finally(() => {
                });
        },
        fetchCrmAds: function (ad_id) {
            var url = "/api/privateCrmAds/" + ad_id;
            var data = {
            }
            this.axios.get(url, { params: data })
                .then((res) => {
                    this.ad = { ...res.data };
                    this.datePickerStartDate = this.ad.start_date;
                    this.datePickerEndDate = this.ad.end_date;
                    this.selectedProducts = this.ad.products;

                    this.oldServiceId = this.ad.service_id;
                    this.oldStartDate = this.ad.start_date;
                    this.oldEndDate = this.ad.end_date;
                    this.oldProducts = [...this.ad.products];
                    this.oldCost = this.ad.cost;
                }).catch(() => {
                }).finally(() => {
                });
        },
        addProduct() {
            this.selectedProducts.push({
                "id": "",
                "name": "",
            });
        },
        delProduct(productId) {
            this.selectedProducts = this.selectedProducts.filter(
                (item) => item.id !== productId
            );
        },
        showSelectProduct(productId, index) {
            this.modalShow = true;
            this.selectedProductId = productId;
            this.selectedProductIndex = index;
            this.$modal.show('selectProduct');
        },
        updateProduct(selectProduct) {
            this.selectedProducts[selectProduct.selectedProductAndRateIndex] = {
                "id": selectProduct.productId,
                "name": selectProduct.productName,
            }
            this.$modal.hide('selectProduct');
        },
        //削除モーダル オープン・クローズ
        openDeleteModal() {
            this.$modal.show('deleteModal');
        },
        closeDeleteModal() {
            this.$modal.hide('deleteModal');
        },
        modalClosed(modalName) {
            this.modalShow = false;
            this.$modal.hide(modalName);
        },
        modalClose() {
            this.$emit('modalClosed');
        },
        filteredService() {
            let result = [];
            let list = [30, 35];
            for (var idx in this.services) {
                let service = this.services[idx];
                if (list.includes(service.id)) {
                    result.push(service);
                }
            }
            return result;
        }
    }
}

</script>


<style scoped lang="sass">
.connectionContainer
    height: 100%
    width: 100%
    margin: 0
    padding: 10px
    display: inline-grid
    grid-template-rows: 40px 1fr 40px
    grid-row-gap: 10px
    .cancelBtn
        width: 100px
        background-color: #ccc
        border: 1px solid #ccc
    .deleteBtn
        width: 100px
        background-color: #ff5252
        border: 1px solid #ff5252
    .connectionHeader
        display: flex
        align-items: center
        font-size: 1.5rem
        justify-content: center
        .modal_title
            font-size: 1.8rem
    .connectionContents
        display: inline-grid
        overflow: auto
        .modal_form
            padding: 32px
            h3
                font-size: 1.6rem
                font-weight: 700
                margin-bottom: 24px
            p
                font-size: 1.4rem
                color: #777
            .modal_input
                margin-bottom: 24px
                display: flex
                justify-content: start
                align-items: center
                label
                    font-size: 1.4rem
                    width: 30%

                input
                    border: 1px solid $grayColor
                    padding: 10px
                    text-align: left
                    width: 30%
                    &:focus
                        outline: 2px solid $mainColor
                select
                    padding: 10px
                    width: 30%
        .modal_submit
            display: flex
            justify-content: center
    .modal_delete
        padding: 24px
        p
            font-size: 1.6rem
        .delete_btns
            margin-top: 40px
            display: flex
            justify-content: space-evenly
    .connectionFooter
        display: flex
        justify-content: start
    .dispAdMenu
        display: inline-block
        background: $mainColor
        color: $whiteColor
        cursor: pointer
        overflow: hidden
        height: 30px;
        padding: 7px
        margin-right: 10px
        position: relative
        width: 150px
        &::befo0e
            background: $whiteColor
            top: 0
            content: ''
            height: 100%
            left: 0
            position: absolute
            transform: translate(0%, 100%)
            transition: all .3s ease-in-out
            width: 150px
        &::after
            background: $whiteColor
            content: ''
            height: 16px
            position: absolute
            right: 8px
            transform: rotate(45deg)
            transition: all .3s ease-in-out
            top: 6px
            width: 16px
        &:hover
            color: $grayColor
            &::before
                transform: translate(0%, 0%)
            &::after
                background: $grayColor
                transform: rotate(225deg)
        .productName
            display: block
            position: relative
            width: 100px
    .selected
        background: $whiteColor
        color: $grayColor
        &::before
            transform: translate(0%, 0%)
        &::after
            background: $grayColor
            transform: rotate(225deg)
.copyBtn
    margin-left: 50px
    background: $grayColor
    border: 1px solid $grayColor
    &:hover
        border: 1px solid $grayColor
.copyError
    margin-top: 10px
    text-align: center
    color: red
    font-size: 1.4rem
</style>
